// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__14jP4","productName":"Table_productName__1cEA9"};